import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import type React from 'react'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'

import { useArtboardMode } from '@/hooks'
import type { AppState } from '@/types'

const MainNotificationRules: React.FC = () => {
  const dispatch = useDispatch()

  const id = useSelector(migrationProjectSelector.getProjectId)
  const createdAt = useSelector(migrationProjectSelector.getProjectCreatedAt)
  const ownerId = useSelector(migrationProjectSelector.getProjectOwnerId)

  const { arrows, edit } = useArtboardMode()

  const isSymbolSelected = useSelector<AppState, boolean>(
    ({ canvas }) => canvas.symbol.selectedSymbol !== null
  )

  const isReadOnlyProject = useSelector(
    migrationProjectSelector.getProjectLegacyAccessTypeIsReadOnly
  )

  const location = useLocation()
  const { uuid } = useParams<{ uuid: string | undefined }>()

  const isArtboardRoute =
    location.pathname === '/' || location.pathname === `/${uuid}`

  useEffect(() => {
    if (!isArtboardRoute) {
      dispatch(
        notificationActionCreators.setClearNotification({
          toastContainerId: 'main',
        })
      )
      return
    }

    if (isReadOnlyProject) {
      return
    }

    if (arrows) {
      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.ARROW_MODE,
        })
      )
      return
    }

    if (edit && isSymbolSelected) {
      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.SYMBOL_SELECTED,
        })
      )
      return
    }

    dispatch(
      notificationActionCreators.setClearNotification({
        toastContainerId: 'main',
      })
    )
  }, [
    arrows,
    edit,
    location,
    uuid,
    isReadOnlyProject,
    isSymbolSelected,
    id,
    ownerId,
    createdAt,
  ])

  return null
}

export default MainNotificationRules
